export const formatPrice = (price: Dinero.Dinero, lang?: string) =>
  new Intl.NumberFormat(lang, {
    style: "currency",
    currency: price.getCurrency(),
  })
    .format(price.toUnit())
    .replace(/\s/g, "");
